/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

interface AllNewsComponentProps {
  newsForCategories: any;
  category: any;
}

const AllNewsComponent: React.FC<AllNewsComponentProps> = ({
  newsForCategories,
  category,
}) => {
  // Filtrar las noticias según la categoría seleccionada y agregar la categoría a cada post
  const filteredNews =
    category === undefined
      ? newsForCategories?.Categories?.flatMap((categorie: any) =>
          categorie.posts.map((post: any) => ({
            ...post,
            category_name: categorie.category, // Asignamos el nombre de la categoría
            category_id: categorie.category_id, // Asignamos el nombre de la categoría
          }))
        )
      : newsForCategories?.Categories?.filter(
          (categorie: any) => categorie.category_id === category
        ).flatMap((categorie: any) =>
          categorie.posts.map((post: any) => ({
            ...post,
            category_name: categorie.category, // Asignamos el nombre de la categoría
            category_id: categorie.category_id, // Asignamos el nombre de la categoría
          }))
        );

  return (
    <>
      <div className="container-all-news-component">
        <div className="title-all-news-component">Todas las noticias</div>
        <div className="categories-all-news-component row">
          <div className="col-xl-3 col-md-6 col-sm-6 col-6 mb-4">
            <Link
              to="/noticias"
              className={`category ${category === undefined ? "active" : ""}`}
            >
              Todas las novedades
            </Link>
          </div>
          {newsForCategories?.Categories?.map((item: any) => (
            <div
              key={item?.category_id}
              className="col-xl-3 col-md-6 col-sm-6 col-6 mb-4"
            >
              <Link
                to={`/noticias/${item?.category_id}`}
                className={`category ${
                  category === item?.category_id ? "active" : ""
                }`}
              >
                {item?.category}
              </Link>
            </div>
          ))}
        </div>
        <div className="news-all-news-component row align-items-stretch">
          {filteredNews?.map((item: any) => (
            <div
              key={item?.id}
              className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4 d-flex"
            >
              <div
                className={`new-all-news-component ${
                  item?.template === "color3" ? "gris" : "azul"
                } ${item?.template} flex-grow-1`}
                style={
                  item?.template === "color1"
                    ? {
                        backgroundImage: `url(https://manager.hyundaicolombia.co/${item?.media?.url})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }
                    : {
                        backgroundColor: `${
                          item?.template === "color2" ? "#002E6B" : "#DBDBDB"
                        }`,
                      }
                }
              >
                <Link
                  to={`/noticias/${item?.category_id}/${item?.slug}`}
                  className="internal-container-all-news-component"
                >
                  <div className="description">{item?.title}</div>
                  <div className="subtitle">{item?.category_name}</div>
                  <Link
                    to={`/noticias/${item?.category_id}/${item?.slug}`}
                    className="readMore"
                  >
                    Leer más
                  </Link>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AllNewsComponent;
